import application from 'application/application';

import moment from 'moment';

application

	.directive('ngDateAfter', () => ({
		require: 'ngModel',
		scope: {
			ngDateAfter: '='
		},
		link(scope, element, attrs, controller) {

			var format = attrs.ngDateFormat || 'DD/MM/YYYY';

			controller.$validators.dateAfter = modelValue => {

				if (controller.$isEmpty(modelValue) || !scope.ngDateAfter)

					return true;

				return moment(modelValue, format, true).isAfter(moment(scope.ngDateAfter, format, true));

			};

		}
	}));
